export default __webpack_public_path__ + "static/media/chevron-right-red.1a0cfc0d.svg";